import React, {useEffect, useState} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import api from '../../services/api';
import {Pagination, Table} from 'antd';
import Button from '@material-ui/core/Button';
import {uploadFile} from '../../util/utils';
import moment from 'moment';
import {S3_HOST} from '../../enviroment';

OrderPurchase.propTypes = {
  //
};

function OrderPurchase(props) {
  const [data, setData] = useState([]);

  const columns = [
    {
      title: 'Fecha de envió de orden de compra',
      dataIndex: 'createdAt',
      render: (x) => moment(x).format('YYY-MM-DD HH:mm'),
    },
    {title: 'Estado de procesamiento', dataIndex: 'status'},
    {
      title: 'Archivo',
      render: (data) => {
        return (
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => {
              const url = `${S3_HOST}/${data.path_file}`;
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.target = '_blank';
              a.download = data.path_file.split('/').pop();
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            }}
          >
            Descargar archivo
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    getData(0);
  }, []);

  function getData(skip) {
    api.purchaseOrders.findAll({query: {$skip: skip}}).then((data) => {
      setData(data);
    });
  }

  function onUpload() {
    // uploadFile
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    input.onchange = (e) => {
      const file = e.target.files[0];
      uploadFile(file, {
        path: 'purchase-orders',
        name: moment().unix(),
      }).subscribe((data) => {
        api.purchaseOrders.create({path_file: data.fileKey}).then(() => {
          getData();
        });
      });
    };
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  }

  return (
    <Box mb={2}>
      <Box mb={2}>
        <Typography>Ordenes de compra</Typography>
      </Box>
      <Box mb={2}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={onUpload}
        >
          Subir archivo
        </Button>
      </Box>
      {data.length ? (
        <>
          <Table
            columns={columns}
            rowKey={(item) => item.id}
            dataSource={data.reverse()}
            pagination={false}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              paddingTop: 15,
            }}
          >
            <Pagination
              total={data.length}
              showSizeChanger={false}
              defaultPageSize={10}
              defaultCurrent={1}
              onChange={(current, pageSize) => {
                getData((current - 1) * pageSize);
              }}
            />
          </div>
        </>
      ) : (
        <div>No hay ordenes de compra</div>
      )}
    </Box>
  );
}

export default OrderPurchase;
